import { ReactElement } from "react";

export const LocationStep = (): ReactElement => {
  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    ></div>
  );
};
